import { render, staticRenderFns } from "./demo1.vue?vue&type=template&id=12747f6c&scoped=true"
import script from "./demo1.vue?vue&type=script&lang=js"
export * from "./demo1.vue?vue&type=script&lang=js"
import style0 from "./demo1.vue?vue&type=style&index=0&id=12747f6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12747f6c",
  null
  
)

export default component.exports